import { Injectable } from '@angular/core';
import { AppConfigService } from '@dexio/common';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IssueService {

  constructor(private readonly configs: AppConfigService, private readonly http: HttpClient) { }

  submitIssue(projectId: string, data: any) {    
    return this.http.post(`${this.configs.get().apiUrl}/projects/${projectId}/issues`, data);
  }
  getIssues(projectId: string): Observable<any> {
    return this.http.get(`${this.configs.get().apiUrl}/projects/${projectId}/issues`)
    .pipe(map((_: any) => { return (_.issues) ? _.issues : null; }));
  }
  suppressDocument(projectId: string, documentId: any) {    
    return this.http.post(`${this.configs.get().apiUrl}/projects/${projectId}/documents/${documentId}/suppress`, {});
  }
}
